import React, { useState, useEffect } from "react";

import { useAuthContext } from "../../context/AuthContext";
import useUserPokemons from "../../hooks/Pokemons/useUserPokemon";
import PokemonItem from "./PokemonItem";
import PokemonDetails from "./PokemonDetails";
import styles from "../../styles/PokemonList.module.css";
import getTypeAura from "../../utils/TypeAura";
import getFirstTypeColor from "../../utils/FirstTypeColor";
import getSecondTypeColor from "../../utils/SecondTypeColor";

const UserPokemonList = ({ period, onClose }) => {
  const { user } = useAuthContext();
  const { userPokemons, isLoading } = useUserPokemons();
  console.log("userPokemons:", userPokemons);
  const [selectedPokemon, setSelectedPokemon] = useState(null);
  const [checked, setChecked] = useState(false);
  const [visible, setVisible] = useState(false);
  const [fadeOut, setfadeOut] = useState(true);
  const [blur, setBlur] = useState(false);
  const sizeClassName =
    selectedPokemon?.size === "Petit"
      ? styles.petit
      : selectedPokemon?.size === "Grand"
      ? styles.grand
      : "";

  useEffect(() => {
    if (userPokemons?.length > 0 && !selectedPokemon) {
      setSelectedPokemon(userPokemons[0]);
      console.log("selectedPokemon:", selectedPokemon);
    }
  }, [userPokemons, selectedPokemon]);

  if (isLoading) {
    return;
  }

  const handlePokemonClick = (pokemon) => {
    setSelectedPokemon(pokemon);
  };

  if (!userPokemons || userPokemons.length === 0) {
    return <div>Aucun Pokémon</div>;
  }

  const checkedClassName = checked ? styles.checked : "";
  const visibleClassName = visible ? styles.visible : "";
  const fadeOutClassName = fadeOut ? styles.fadeOut : "";
  const blurClassName = blur ? styles.blur : "";

  const handleVisibleAndChecked = () => {
    if (!checked) {
      // setTimeout(() => setBlur(false), 400);
      setTimeout(() => setfadeOut(false), 100);
      setChecked(true);
    } else {
      // setBlur(true);
      setTimeout(() => setfadeOut(true), 200);
      setChecked(false);
    }
  };

  console.log(selectedPokemon?.type);

  return (
    <div>
        <div className={styles.pokemonPageBlurredBg}>
        </div>
      <div
        className={`${styles.pokemonPageContainer}`} /* style={checked ? {backdropFilter: 'blur(40px)'} : {}}*/
      >
        <div className={`${styles.videoContainer}`}>
          <div
            style={{ backgroundColor: getTypeAura(selectedPokemon?.type) }}
            className={styles.typeColor}
          ></div>
          <video
            src={selectedPokemon?.video}
            className={sizeClassName}
            autoPlay
            loop
            muted
          ></video>
        </div>

        <div
          className={`${styles.pokemonDetailsContainer} ${checkedClassName}`}
          onClick={handleVisibleAndChecked}
        >
          <PokemonDetails
            pokemon={selectedPokemon}
            period={period}
            onClose={onClose}
          />
        </div>
        <div className={`${styles.pokemonListContainer}`}>
          <div
            className={`${styles.typeBackground} `}
            style={{
              opacity: 0.5,
              backgroundImage: `linear-gradient(to right, ${getFirstTypeColor(
                selectedPokemon?.type
              )}, ${
                selectedPokemon?.type[1]
                  ? getSecondTypeColor(selectedPokemon?.type)
                  : getFirstTypeColor(selectedPokemon?.type)
              })`,
            }}
          ></div>
          <ul
            className={`${styles.pokemonList}${visibleClassName} ${fadeOutClassName} ${blurClassName} list`}
          >
            {userPokemons.map((pokemon) => (
              <PokemonItem
                key={pokemon.id || pokemon.nom}
                pokemon={pokemon}
                onClick={handlePokemonClick}
                isSelected={selectedPokemon?.id === pokemon.id}
                period={period}
              />
            ))}
          </ul>
          <div className={`${styles.closeButtonContainer}`}>
            {/* <div className={`${styles.bottomPokeball} pokeball`}>
                        <img src="assets/icons/UI/bottom_pokeball.png" alt="" />
                    </div> */}
            <div className={`${styles.closeButton} button`}>
              <div
                className={`${styles.closeButtonIcon} icon`}
                onClick={onClose}
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 669 774"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M345.71 0.439453H93.33C78.07 0.439453 65.7 12.8095 65.7 28.0695C65.7 43.3295 78.07 55.6994 93.33 55.6994H345.71C491.47 55.6994 610.33 173.039 612.79 318.229C615.32 467.649 489.08 589.949 339.64 589.949H94.31L95.48 588.829L170.66 513.649C181.45 502.859 181.45 485.359 170.66 474.569C159.87 463.779 142.37 463.779 131.58 474.569L9.04001 597.109C-1.74999 607.899 -1.74999 625.399 9.04001 636.189L138.31 765.459C149.1 776.249 166.6 776.249 177.39 765.459C188.18 754.669 188.18 737.169 177.39 726.379L96.23 645.219H338.85C514.28 645.219 662.75 507.929 667.95 332.579C673.35 150.379 526.71 0.439453 345.71 0.439453Z"
                    fill=" rgb(83, 80, 80)"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPokemonList;
